/**
 * Centralized event definitions for analytics tracking.
 * This file defines all trackable events across the application.
 * 
 * Pattern: Event names are namespaced (category_action) for easy filtering.
 * Each event has defined properties for consistent data structure.
 */

export const AnalyticsEvents = {
  // User lifecycle
  USER_SIGNED_UP: 'user_signed_up',
  USER_SIGNED_IN: 'user_signed_in',
  USER_SIGNED_OUT: 'user_signed_out',

  // Search
  SEARCH_QUERY: 'search_query',
  SEARCH_FILTER_APPLIED: 'search_filter_applied',
  WEB_SEARCH_QUERY: 'web_search_query',
  SEARCH_RESULT_CLICKED: 'search_result_clicked',
  WEB_SEARCH_RESULT_CLICKED: 'web_search_result_clicked',
  SEARCH_TAB_SWITCHED: 'search_tab_switched',
  SEARCH_CLEARED: 'search_cleared',

  // Recipe interactions
  RECIPE_VIEWED: 'recipe_viewed',
  RECIPE_IMPORTED: 'recipe_imported',
  RECIPE_SHARED: 'recipe_shared',
  RECIPE_FAVORITED: 'recipe_favorited',
  RECIPE_UNFAVORITED: 'recipe_unfavorited',

  // Lists
  LIST_CREATED: 'list_created',
  LIST_ITEM_ADDED: 'list_item_added',
  LIST_ITEM_REMOVED: 'list_item_removed',
  LIST_EXPORTED: 'list_exported',

  // Meal planning
  MEAL_PLAN_CREATED: 'meal_plan_created',
  MEAL_PLAN_RECIPE_ADDED: 'meal_plan_recipe_added',

  // Books
  BOOK_VIEWED: 'book_viewed',
  BOOK_CHAPTER_OPENED: 'book_chapter_opened',

  // Errors
  ERROR_OCCURRED: 'error_occurred',
};

/**
 * User property keys for identifying users
 */
export const UserProperties = {
  EMAIL: 'email',
  NAME: 'name',
  ROLE: 'role',
  HOUSEHOLD_ID: 'household_id',
  CREATED_AT: 'created_at',
};
